import React from "react";

function DebitCell(data) {
  return <div>{data?.debit === 0 ? "" : data?.debit}</div>;
}

export default DebitCell;
